import React from 'react';
import UnifiedModal from '../UnifiedModal';
import { useTranslation } from 'react-i18next';

const VideoModal = ({ show, onHide, videoId, dir }) => {
  const { t } = useTranslation();

  if (!videoId) return null;

  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

  return (
    <UnifiedModal
      show={show}
      onHide={onHide}
      title={t('videoModalTitle')}
      dir={dir}
      className="video-modal"
      showFooter={false}
    >
      <div className="video-container">
        <iframe
          width="100%"
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Car Video"
        ></iframe>
      </div>
    </UnifiedModal>
  );
};

export default VideoModal;